import { render, staticRenderFns } from "./GoodsPromotion.vue?vue&type=template&id=14ac02ae&"
import script from "./GoodsPromotion.vue?vue&type=script&lang=js&"
export * from "./GoodsPromotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports